import { Button, Space, Typography } from "antd";

export default function TextPanel({ onAddText }) {
  return (
    <div className="invitation-builder__text-panel">
      <Typography.Paragraph type="secondary">
        Add editable text blocks. Click a block on the canvas to format it in
        the toolbar below.
      </Typography.Paragraph>
      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        <Button block type="primary" onClick={() => onAddText("heading")}>
          Add heading
        </Button>
        <Button block onClick={() => onAddText("subheading")}>
          Add subheading
        </Button>
        <Button block onClick={() => onAddText("body")}>
          Add body text
        </Button>
      </Space>
    </div>
  );
}
